export const namespaced = true;
const defaultData = {
    signature: {
        contactAddress: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            street: '',
            postcode: '',
            city: ''
        },
        isPersonal: true
    }
}
export const state = () => (defaultData);

export const getters = {
    getSignature: state => state.signature,
}

export const mutations = {
    mutateSignature(state, signature) {
        state.signature = signature
    }
};

export const actions = {
    setSignature({commit}, signature) {
        return new Promise((resolve, reject) => {
            commit('mutateSignature', signature);
            resolve()
        })
    },
    resetData({commit}) {

        return new Promise((resolve, reject) => {
            commit('mutateSignature', defaultData);
            resolve()
        })
    }
};

